// Action Constants
import { CityConfig } from "../../constants/action-constants/CityConfigActionConstants";

// Actions related to "City Config"
export const getCityConfig = (cityId, configType) => ({
  type: CityConfig.GET_CITY_CONFIG,
  payload: { cityId, configType },
});

export const clearCityConfig = () => ({
  type: CityConfig.CLEAR_CITY_CONFIG,
});

export const uploadCityConfig = (cityId, files, configType, isTouchPoint) => ({
  type: CityConfig.UPLOAD_CITY_CONFIG,
  payload: { cityId, files, configType, isTouchPoint },
});

export const downloadCityConfigExcelTemplate = (configType, isTouchPoint) => ({
  type: CityConfig.DOWNLOAD_CITY_CONFIG_EXCEL_TEMPLATE,
  payload: { configType, isTouchPoint },
});
